module.exports = __webpack_public_path__ + "static/media/ageConvertor.3c779eab.png";